import { render } from "./styleLoader.vue?vue&type=template&id=22d090f3"
import script from "./styleLoader.vue?vue&type=script&lang=js"
export * from "./styleLoader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mymac/Documents/Digitala/MODC/modc-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__